/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hasRole } from 'linced-app/utils/roles';
import Staff from '@linc-technologies/linced-common/enums/roles/staff';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import config from 'linced-app/config/environment';

export default class ApprovalController extends Controller {
  @service
  fetch;

  @service
  session;

  @service
  options;

  @service
  paperToaster;

  @service
  roles;

  @service
  router;

  @alias('model.rollReturn')
  rollReturn;

  @hasRole(Staff.APPROVE_ROLL_RETURNS)
  canApprove;

  @optionAlias('nzMOE:schoolType:decile')
  decile;

  @computed('decile')
  get donationSchemeAvailable() {
    return this.decile > 0 && this.decile < 8;
  }

  @tracked
  currentStep = 0;

  @action
  setCurrentStep(value) {
    this.currentStep = value;
  }

  // inProgress is a flag used to disable the approve and reject buttons while either process is in progress.
  @tracked
  inProgress = false;

  // donationScheme stores the value of the user's selection for the "donation scheme" question in the Declaration step.
  @tracked
  donationScheme = '';

  @action
  setDonationScheme(value) {
    this.donationScheme = value;
  }

  @tracked
  step;

  @action
  print() {
    let printer = window.open(
      'about:blank',
      '_blank',
      'menubar=yes,location=no,resizable=yes,scrollbars=yes,status=no,height=700,width=1024',
    );
    printer.document.write(
      `<html><head><title>Principal's Declaration</title></head><body >`,
    );
    printer.document.write(
      document.getElementById('printDeclaration').innerHTML,
    );
    printer.document.write(`</body></html>`);

    later(
      this,
      (printer) => {
        printer.print();
        printer.close();
      },
      printer,
      500,
    );
  }

  @action
  back() {
    window.history.back();
  }

  @action
  approve() {
    this.inProgress = true;
    let params = {};
    if (this.rollReturn.rollReturnMonth === 'J') {
      if (this.donationSchemeAvailable || isEmpty(this.decile)) {
        // Either the donation scheme is available to this school (based on decile),
        // or we can't tell (because their decile isn't set at all), so we've left it to the school to determine.
        params.donationScheme = this.donationScheme;
      } else {
        params.donationScheme = '9'; // Not Applicable (based on configured decile).
      }
    }
    let options = {
      data: JSON.stringify(params),
    };
    let url = `${config.APP.apiHost}/providers/nz/moe/v4/rollreturns/rollreturns/${this.rollReturn.id}/:approve`;
    this.fetch.post(url, options).then(
      () => {
        // Roll return approved successfully.
        this.router.transitionTo(
          'nz-moe.roll-returns.roll-return',
          this.rollReturn.id,
        );
      },
      () => {
        this.paperToaster.show(
          'Roll Return approval failed.  Please try again, or contact Hero support for assistance.',
          {
            duration: 4000,
            position: 'top right',
            toastClass: 'warning',
          },
        );
        this.inProgress = false;
      },
    );
  }

  @action
  reject() {
    this.inProgress = true;
    let url = `${config.APP.apiHost}/providers/nz/moe/v4/rollreturns/rollreturns/${this.rollReturn.id}/:reject`;
    this.fetch.post(url).then(
      () => {
        // Roll return rejected successfully.
        this.router.transitionTo(
          'nz-moe.roll-returns.roll-return',
          this.rollReturn.id,
        );
      },
      () => {
        this.paperToaster.show(
          'Roll Return rejection failed.  Please try again, or contact Hero support for assistance.',
          {
            duration: 4000,
            position: 'top right',
            toastClass: 'warning',
          },
        );
        this.inProgress = false;
      },
    );
  }

  reset() {
    this.step = 0;
    this.inProgress = false;
    this.donationScheme = '';
  }
}
